import styled from 'styled-components';
import { Link } from 'react-router-dom';

const buttonStyles = `
  padding: 1rem 2rem;
  font-family: 'Bungee', cursive;
  font-size: 0.9rem;
  text-decoration: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  text-shadow: 2px 2px 3px rgba(0,0,0,0.3);

  /* Reverting to the static Muted Teal theme */
  background-color: #4B8E8D; 
  color: #EDE7D9;
  border: 3px solid #296C6B;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    transform: translateY(0);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 500px) {
    font-size: 0.9rem;
    padding: 0.8rem 1.5rem;
  }
`;

export const RetroButton = styled.button`
  ${buttonStyles}
`;

export const RetroLinkButton = styled(Link)`
  ${buttonStyles}
`; 